<ion-content>
    <import-clients-mobile-page *ngIf="template === 'mobile'"></import-clients-mobile-page>
    <import-clients-desktop-page *ngIf="template === 'desktop'"></import-clients-desktop-page>
</ion-content>
